import { useEffect, useRef, useState } from "react";
import ScoreSubmit from "@/components/landing/games/ScoreSubmit";

export default function TightenTheBolt() {
  const [torque, setTorque] = useState(0);
  const [running, setRunning] = useState(false);
  const startRef = useRef(null);
  const [finalScore, setFinalScore] = useState(null);
  const tight = torque >= 100;

  useEffect(() => {
    if (tight && startRef.current && finalScore === null) {
      setFinalScore(Math.max(1, Math.round((Date.now() - startRef.current) / 100)));
    }
  }, [tight, finalScore]);

  useEffect(() => {
    if (!running || tight) return;
    const decay = setInterval(() => setTorque((t) => Math.max(0, t - 3)), 400);
    return () => clearInterval(decay);
  }, [running, tight]);

  const tap = () => {
    if (tight) return;
    if (!startRef.current) startRef.current = Date.now();
    setRunning(true);
    setTorque((t) => Math.min(100, t + 6));
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E6DCD3] p-6 sm:p-8 shadow-sm text-center" data-testid="tighten-bolt-game">
      <h3 className="font-bold text-base text-[#1E252B]">Tighten the Bolt</h3>
      <p className="text-xs text-[#736B63] mt-0.5 mb-5">Rapid-tap the bolt to hit full torque before it slips back.</p>

      <button
        type="button"
        onClick={tap}
        data-testid="bolt-tap-btn"
        aria-label="Tap to tighten bolt"
        className="mx-auto block w-28 h-28 transition-transform active:scale-95"
        style={{ transform: `rotate(${torque * 1.8}deg)` }}
      >
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <polygon
            points="50,4 90,27 90,73 50,96 10,73 10,27"
            fill={tight ? "#D4691E" : "#8C847B"}
            stroke="#1E252B"
            strokeWidth="3"
          />
          <circle cx="50" cy="50" r="18" fill="#FBF9F5" stroke="#1E252B" strokeWidth="3" />
        </svg>
      </button>

      <div className="max-w-xs mx-auto mt-5">
        <div className="h-3 rounded-full bg-[#F5EFEB] border border-[#E6DCD3] overflow-hidden">
          <div
            className="h-full bg-[#D4691E] transition-[width] duration-150"
            style={{ width: `${torque}%` }}
            data-testid="torque-bar"
          />
        </div>
        <span className="text-xs font-bold text-[#544D45] mt-1 block" data-testid="torque-value">
          Torque: {torque}%
        </span>
      </div>

      {tight && (
        <div className="mt-4" data-testid="bolt-win">
          <p className="text-sm font-semibold text-[#1E252B]">
            Torqued to spec. Nothing I fasten ever comes loose.
          </p>
          <a href="#contact" data-testid="bolt-quote-btn" className="inline-block mt-3 px-5 py-2 rounded bg-[#1E252B] hover:bg-[#D4691E] text-white text-xs font-bold transition-colors">
            Get That Bolt Fixed For Real
          </a>
          {finalScore !== null && <ScoreSubmit game="tighten-the-bolt" score={finalScore} scoreLabel="time pts" />}
        </div>
      )}
    </div>
  );
}
